module.exports = __webpack_public_path__ + "img/columns.24299f19.svg";